/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Cell } from "react-table";
import { FlexContainer, theme } from "@nordcloud/gnui";
import { ButtonWrap } from "~/components/ButtonWrap";
import { TableExpander } from "~/components/Tables/Columns/Expander";

type OrgUnitV2 = {
  cost?: {
    nid: string;
    name: string;
    currentMonth: string;
    previousMonth: string;
  };
  environments?: number;
  nid: string;
  name: string;
  description?: string;
  parentNid?: string;
  businessContext: { id: string };
  type?: { id: string; name: string };
  contact?: { id: string; name: string };
};

export const BusinessContextsSelectorColumns = (
  onUnitSelectHandler: (unitId: string) => Promise<void>
) => [
  ...TableExpander(),
  {
    Header: "Name",
    accessor: "name",
    disableSortBy: true,
    Cell: ({ row }: Cell<OrgUnitV2>) => {
      return (
        <ButtonWrap
          style={{ paddingLeft: `${row.depth}rem` }}
          onClick={() => onUnitSelectHandler(row.original.nid)}
        >
          <FlexContainer alignItems="center">
            {!row.canExpand && (
              <div
                css={{
                  float: "left",
                  marginRight: "1rem",
                  borderRadius: "0.125rem",
                  width: "0.625rem",
                  height: "0.625rem",
                  backgroundColor: theme.color.background.ui05,
                }}
              />
            )}
            {row.original.name}
          </FlexContainer>
        </ButtonWrap>
      );
    },
  },
];
